import { c as _c } from "react/compiler-runtime";
import MaskedInputComponent, { MaskConfig, Props as MaskedInputProps } from '@spa/components/form-group/masked-input.component';
import React, { ReactElement, memo } from 'react';
import { InputMode } from '@spa/components/form-group/InputMode';
type InputDateSlot = 'day' | 'month' | 'year';
export type Props = Omit<MaskedInputProps, 'config'>;
const INPUT_DATE_MASK = '__.__.____';
const INPUT_DATE_DAY_INDEXES: Array<number> = [0, 1];
const INPUT_DATE_MONTH_INDEXES: Array<number> = [3, 4];
const INPUT_DATE_YEAR_INDEXES: Array<number> = [6, 7, 8, 9];
const isDigit = (value: string): boolean => /^[0-9]$/.test(value);
const inputDateSetCharAt = (str: string, index: number, ch: string): string => str.substring(0, index) + ch + str.substring(index + 1);
const formatInputDateValueBySlot = (currentValue: string, slot: InputDateSlot): string => {
  let value: string = currentValue;
  if (slot !== 'year') {
    const [positionChar1, positionChar2] = slot === 'day' ? INPUT_DATE_DAY_INDEXES : INPUT_DATE_MONTH_INDEXES;
    const char1: string = currentValue[positionChar1];
    const char2: string = currentValue[positionChar2];
    if (isDigit(char1) && char2 === '_') {
      value = inputDateSetCharAt(inputDateSetCharAt(currentValue, positionChar1, '0'), positionChar2, char1);
    } else if (char1 === '_' && isDigit(char2)) {
      value = inputDateSetCharAt(inputDateSetCharAt(currentValue, positionChar1, '0'), positionChar2, char2);
    }
  } else {
    const yearRaw: string = INPUT_DATE_YEAR_INDEXES.map((index: number): string => currentValue[index]).join('');
    const digits: string = yearRaw.replace(/_/g, '');
    if (digits.length !== 0) {
      let finalYear: string;
      if (digits.length <= 2) {
        const yy: number = Number(digits);
        if (yy >= 0 && yy <= 20) {
          finalYear = `20${digits.padStart(2, '0')}`;
        } else if (yy >= 20 && yy <= 99) {
          finalYear = `19${digits.padStart(2, '0')}`;
        } else {
          finalYear = digits.padStart(4, '0').slice(-4);
        }
      } else {
        finalYear = digits.padStart(4, '0').slice(-4);
      }
      value = currentValue;
      for (let pos: number = 0; pos < INPUT_DATE_YEAR_INDEXES.length; pos++) {
        const index: number = INPUT_DATE_YEAR_INDEXES[pos];
        value = inputDateSetCharAt(value, index, finalYear[pos]);
      }
    }
  }
  return value;
};
const inputDateSlotFromCursor = (pos: number): InputDateSlot => {
  let value: InputDateSlot;
  if (pos <= 1) {
    value = 'day';
  } else if (pos <= 4) {
    value = 'month';
  } else {
    value = 'year';
  }
  return value;
};
const inputDateNextSlotStart = (slot: InputDateSlot): number => {
  let value: number;
  if (slot === 'day') {
    value = 3;
  } else {
    value = 6;
  }
  return value;
};
const inputDateMaskConfig: MaskConfig = {
  mask: INPUT_DATE_MASK,
  isAllowedChar: isDigit,
  allowedCharClass: '0-9',
  inputMode: InputMode.NUMERIC,
  pattern: '[0-9.]*',
  formatKey: '.',
  onFormatKey: (value: string, cursor: number): {
    value: string;
    cursor: number;
  } => {
    const slot: InputDateSlot = inputDateSlotFromCursor(cursor);
    return {
      value: formatInputDateValueBySlot(value, slot),
      cursor: inputDateNextSlotStart(slot)
    };
  },
  formatOnBlur: (value: string): string => formatInputDateValueBySlot(formatInputDateValueBySlot(formatInputDateValueBySlot(value, 'day'), 'month'), 'year')
};
function InputDateComponent(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <MaskedInputComponent {...props} config={inputDateMaskConfig} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default memo(InputDateComponent);